<app-header-global></app-header-global>
<div class="row allcontent">
    <div [ngClass]="sidebarCollapsed ? 'col-sm-1' : 'col-sm-2'">
        <app-side-overlay-menu></app-side-overlay-menu>

    </div>
    <div [ngClass]="sidebarCollapsed ? 'col-sm-11' : 'col-sm-10'" class="card_div">
   <p class="title custom_heading">Products</p>
        <span *ngFor="let pdata of product,let i=index">
        <a id="link{{i}}" href="{{pdata.link}}" target="_blank"><div class="cards" >
            <div class="imgsec">
                <img style="
    width: 78px;
    height: 78px;
" src="{{pdata.imglink}}" id="img{{i}}" alt="" srcset="">
            </div>
            <div class="discsec">
                <div class="row">
                <div class="pname">
                   {{pdata.name}}
                </div>
                <div class="discription">
                   {{pdata.description}}
                </div>
                </div>
                <div class="row">
                    <div class="col">
                       <!-- <p class="link"><u></u><u>View <i class="fa fa-arrow-up" style=" rotate: 45deg;"
                          aria-hidden="true"></i></u>
                       </p> -->
                       <p class="link">View
                       </p>
                    </div>
                 </div>
            </div>
            
        </div></a>
    </span>
    </div>
</div>
